import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { ar } from './locales/ar'
import { en } from './locales/en'

export const LANGUAGES = {
  ar: { label: 'العربية', dir: 'rtl' },
  en: { label: 'English', dir: 'ltr' },
} as const

export type Language = keyof typeof LANGUAGES

export function applyDocumentLanguage(lang: Language) {
  const el = document.documentElement
  el.lang = lang
  el.dir = LANGUAGES[lang].dir
}

export function initI18n(lang: Language) {
  void i18n.use(initReactI18next).init({
    resources: { ar: { translation: ar }, en: { translation: en } },
    lng: lang,
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    returnNull: false,
  })
  applyDocumentLanguage(lang)
  return i18n
}

export { i18n }
